module.exports = __webpack_public_path__ + "partylineManage/img/ring.613a2550.svg";